import moment from "moment/moment";
import { Selectable } from "../../UI/Selectable";
import Tooltip from "../../UI/Tooltip";
import Text from "../../UI/Text";
// @ts-expect-error pure js
import { Interrogation } from "../../UI/Icons.jsx";
// @ts-expect-error pure js
import { currencyFormatter } from "../../../api/Functions";
// @ts-expect-error pure js
import { useBalanceTypes } from "../../../hooks/use-balances";
// @ts-expect-error pure js
import { classnames } from "../../../utils";
import type { Balance, BalanceTypeCatalog } from "../../../models/balance";
import styles from "./BalanceRecuperableCard.module.css";

/** Charge récupérable dont `montant` est la part refacturable, proratisée à l'occupation. */
export interface BalanceRecuperable extends Balance {
  montantProratise: number;
}

interface BalanceRecuperableCardProps {
  balance: BalanceRecuperable;
  index: number;
}

export default function BalanceRecuperableCard({
  balance,
  index,
}: BalanceRecuperableCardProps) {
  const { balanceTypes } = useBalanceTypes() as {
    balanceTypes?: BalanceTypeCatalog;
  };
  const hasProrata = balance.montantProratise !== balance.montant;
  return (
    <label
      className={classnames(styles.item, hasProrata && styles.itemProrata)}
    >
      <Selectable.Checkbox value={balance.id} index={index} />
      <Text as="span" className={styles.itemText}>
        {moment(balance.date_transac).format("DD/MM/YYYY")} ·{" "}
        {currencyFormatter(Math.abs(balance.montant))}
        {hasProrata && (
          <>
            {" "}
            → {currencyFormatter(Math.abs(balance.montantProratise))}{" "}
            <Tooltip content="Un prorata a été appliqué car le locataire n'était pas présent pendant toute la période de facturation.">
              <Interrogation />
            </Tooltip>
          </>
        )}{" "}
        · {balanceTypes?.[balance.type]?.text || balance.type}
      </Text>
    </label>
  );
}
